import { createApi } from "@reduxjs/toolkit/query/react";
import { buildBaseQuery } from "@app/api";
import { FilterParams } from "types";

import { BlogCreationPayload, IBlog } from "../types/index";

export const blogApi = createApi({
  reducerPath: "blogApi",
  baseQuery: buildBaseQuery(""),
  endpoints: (builder) => ({
    getBlogs: builder.query<{ blogs: IBlog[]; count: number}, FilterParams>({
      query: (params) => {
        const queryString = Object.entries(params)
          .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
          .join('&');

        return `/blogs/dashboard?${queryString}`;
      },
    }),
    getBlogById: builder.query<IBlog, string>({
      query: (blogId) => `/blogs/${blogId}`,
    }),
    createBlog: builder.mutation<void, BlogCreationPayload >({
      query: (body) => ({
        url: "/blogs",
        method: "POST",
        body,
      }),
    }),
    updateBlog: builder.mutation<void, {id: string; body: BlogCreationPayload}>({
      query: ({ id, body }) => ({
        url: `/blogs/${id}`,
        method: "PATCH",
        body,
      }),
    }),
    updateVisibalityInHome: builder.mutation<void, {id: string; activeInHome: boolean}>({
      query: ({ id, activeInHome }) => ({
        url: `/blogs/${id}/info`,
        method: "PATCH",
        body: { activeInHome },
      }),
    }),
    deleteBlog: builder.mutation<void, { id: string }>({
      query: ({ id }) => ({
        url: `/blogs/${id}`,
        method: "DELETE",
      }),
    }),
    deleteBlogInfo: builder.mutation<void, { id: string }>({
      query: ({ id }) => ({
        url: `/blogs/blog-info/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetBlogsQuery,
  useLazyGetBlogsQuery,
  useDeleteBlogMutation,
  useDeleteBlogInfoMutation,
  useCreateBlogMutation,
  useUpdateBlogMutation,
  useLazyGetBlogByIdQuery,
  useUpdateVisibalityInHomeMutation
} = blogApi;
